var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTrustShield1 = function SvgIconTrustShield1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.999,
    d: "M19.994 12.996c0 4.998-3.5 7.497-7.658 8.947a1 1 0 0 1-.67-.01C7.498 20.493 4 17.994 4 12.996V5.998a1 1 0 0 1 1-1c1.999 0 4.498-1.2 6.237-2.719a1.17 1.17 0 0 1 1.52 0C14.506 3.81 16.995 5 18.994 5a1 1 0 0 1 1 .999z"
  })));
};
export default SvgIconTrustShield1;